export { default as CompanyOperationsCompactTableHeader } from './CompanyOperationsCompactTableHeader';
